import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading, adminImpersonation } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  // Allow access if user is authenticated OR admin impersonation is active
  return (user || adminImpersonation) ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
